<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="150px">
      <div style="display: flex;margin: 10px 0;">
        <div class="integra-title">
          <el-input v-model="form.title" :placeholder="$t('message.placeholder.input')"> </el-input>
        </div>
        <div class="integra-delete">
          <span @click="deleteItem" class="el-icon-delete delete"></span>
        </div>
      </div>
      <!-- <el-divider></el-divider> -->
      <el-form-item :label="$t('message.table.isEnabled')">
        <el-switch v-model="form.checked" />
      </el-form-item>

      <div>
        <el-form-item :label="$t('message.title.IntegrationHost')" prop="hostname">
          <el-input v-model="form.hostname"></el-input>
        </el-form-item>
        <!-- <el-form-item label="端口号:" prop="Integration"> -->
        <el-form-item :label="$t('message.title.IntegrationPost')" prop="post">
          <el-input type="number" v-model="form.post"></el-input>
        </el-form-item>
        <!-- <el-form-item label=ERP账号:" prop="Integration"> -->
        <el-form-item :label="$t('message.title.IntegrationUser')" prop="IntegrationUser">
          <el-input v-model="form.Integration" auto-complete="new-password"></el-input>
        </el-form-item>
        <!-- <el-form-item label="ERP密码:" prop="password"> -->
        <el-form-item :label="$t('message.title.IntegrationPassWord')" prop="password">
          <el-input v-model="form.password" auto-complete="new-password" :type="passw"></el-input>
        </el-form-item>

      </div>


    </el-form>

  </div>
</template>

<script>
import axios from 'axios';
export default {

  data() {
    return {
      editable: true,
      old_form: {},
      passw: "password",
      form: {
        hostname: '',
        name: '',
        password: '',
        checked: false,
      },
      rules: {
        hostname: {
          required: true, message: this.$t("message.error.IntegrationHost"), trigger: 'blur'
        },
        Integration: [
          { required: true, message: this.$t("message.error.IntegrationAccounts"), trigger: 'blur' },
          { type: 'Integration', message: this.$t("message.error.IntegrationAddress"), trigger: ['blur', 'change'] }
        ],
        password: {
          required: true, message: this.$t("message.error.IntegrationPassWord"), trigger: 'blur'
        },
        post: {
          required: true, message: this.$t("message.error.post"), trigger: 'blur'
        }
      }
    }
  },
  props: ['data'],
  methods: {

    deleteItem() {
      this.$emit('delete')
    },

    pushData() {
      return this.form
      // this.$refs.form.validate((valid)  =>{
      //   if (valid) {
      //     return this.form
      //   }else {
      //     this.$message.error(this.$t('message.error.save'));
      //     return false;
      //   }
      // })
    },

  },
  mounted() {
    console.log(this.data);
    this.form = { ...this.data }
  }

}
</script>

<style scoped>
.delete {
  cursor: pointer;
}

.delete:hover {
  color: #409EFF;
}

.integra-title {
  flex: 1
}

.integra-title ::v-deep .el-input__inner {
  width: 80%;
  font-size: 16px;
  font-weight: 600;
  border-radius: 0px;
  border-width: 0;
  border-bottom-width: 1px;
  padding: 3px;
  /*outline: medium;*/
}

.integra-delete {
  flex: 0 20px;
  padding: 12px 0;
}
</style>
